import { helper } from 'utils';
import config from 'config';
import { getStoredAuthToken, storeAuthToken } from 'utils/auth';

const getFbUserData = params => {
  return new Promise((resolve, rejects) => {
    window.FB.api('/me', params, response => {
      if (!response || response.error) {
        rejects(new Error('FAILED - get FB user public data'));
      } else {
        resolve(response);
      }
    });
  });
};

const getLocalStoredUserData = () => {
  const user = getStoredAuthToken();
  return user && JSON.parse(user);
};

const handleUserResponse = async ({ status, authResponse }) => {
  const userFields = { fields: 'picture' };

  if (status === 'unknown') {
    const asfbu = getLocalStoredUserData();
    if (!asfbu || asfbu.expiresIn < Date.now() / 1000) return;
    userFields.access_token = asfbu.accessToken;
  }

  if (status === 'not_authorized') return;

  if (status === 'connected') {
    const fbus = {
      expiresIn: authResponse.data_access_expiration_time,
      accessToken: authResponse.access_token,
    };
    storeAuthToken(JSON.stringify(fbus));
    userFields.access_token = authResponse.access_token;
  }

  const [user, error] = await helper.asyncWrapper(() => getFbUserData(userFields));
  return !error && user;
};

const logout = () => {
  return new Promise(resolve => {
    try {
      window.FB.getLoginStatus(response => {
        if (response?.status === 'connected') {
          window.FB.logout(() => {
            document.location.reload();
          });
        }
      });
    } catch (error) {
      resolve(null);
    }
  });
};

const login = () => {
  // const permissions = { scope: 'public_profile' };
  return new Promise(() => {
    try {
      const fb_login_url = `https://www.facebook.com/v17.0/dialog/oauth?client_id=${config.fb.appId}&redirect_uri=${config.fb.redirectUri}&response_type=token&state=qwerty`;
      window.location.replace(fb_login_url);
      // window.FB.login(response => {
      //     handleUserResponse(response).then((user) => {resolve(user)});
      // }, permissions);
    } catch (error) {
      throw new Error('FAILED - facebook login.');
    }
  });
};

const checkStatus = () => {
  return new Promise(resolve => {
    try {
      window.FB.getLoginStatus(response => {
        handleUserResponse(response).then(user => {
          resolve(user);
        });
      });
    } catch (error) {
      throw new Error('FAILED - facebook user status');
    }
  });
};

const initSdk = () => {
  return new Promise(resolve => {
    try {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: config.fb.appId,
          xfbml: true,
          version: 'v18.0',
          cookie: true,
          status: true,
          localStorage: true,
        });
        resolve();
      };

      ((d, s, id) => {
        let js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = config.fb.sdk;
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    } catch (error) {
      throw new Error('FAILED - facebook sdk init');
    }
  });
};

const fbservice = {
  login,
  logout,
  checkStatus,
  initSdk,
  handleUserResponse,
};

export default fbservice;
